import { createSelector } from 'reselect';

export const getAllItems = state => state.cart.composition;

export const totalCountItemsSelector = createSelector(getAllItems, items =>
  items.reduce((acc, item) => acc + item.count, 0),
);

export const bonusesInCompositionSelector = createSelector(getAllItems, items =>
  items.filter(item => item.type === 'bonus'),
);
